import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ModalConfirm } from '../modal.actions';

@Component({
  selector: 'mojo-note-rejected-modal',
  templateUrl: './modal-note-rejected.component.html',
  styleUrls: ['./modal-note-rejected.component.scss'],
})
export class ModalNoteRejectedComponent {
  comments: UntypedFormControl = new UntypedFormControl();

  @Output()
  reasonsChange = new EventEmitter<string[]>();

  reasons = [
    {
      name: 'Skills do not fit job',
      value: 'SkillsDoNotFitJob',
      selected: false,
    },
    {
      name: 'Need more experience',
      value: 'NeedMoreExperience',
      selected: false,
    },
    {
      name: 'Need less experience',
      value: 'NeedLessExperience',
      selected: false,
    },
    {
      name: 'Lack relevant experience',
      value: 'LackRelevantExperience',
      selected: false,
    },
    {
      name: 'Preferred another candidate',
      value: 'PreferredAnotherCandidate',
      selected: false,
    },
    {
      name: 'Not a culture fit',
      value: 'NotACultureFit',
      selected: false,
    },
    {
      name: 'Other',
      value: 'Other',
      selected: false,
    },
  ];

  form: UntypedFormGroup = new UntypedFormGroup({
    comments: this.comments,
  });

  constructor() {}

  getConfirmAction() {
    return [new ModalConfirm({ content: this.getComments() })];
  }

  isDisableSave() {
    return (
      this.isAnyReasonSelected() ||
      (this.isSelected('NotACultureFit') && this.isSelected('Other') && !this.comments.value)
    );
  }

  isAnyReasonSelected() {
    return this.reasons.filter((reason) => reason.selected === true).length === 0;
  }

  isSelected(value: string) {
    return !!this.reasons.find((reason) => reason.value === value && reason.selected === true);
  }

  getComments() {
    const selectedReasons = this.reasons
      .filter((reason) => reason.selected === true)
      .map((reason) => reason.name);
    return `${selectedReasons.join('. ')}${
      !!this.comments.value ? ': ' + this.comments.value : ''
    }.`;
  }
}
